// Super Admin passcode for System Settings > Custom.
// Generate the values with tools/superadmin-passcode-generator.html and paste them here.
// Only the salt and PBKDF2-SHA256 hash are stored, never the passcode itself.
// While salt or hash is empty, Super Admin cannot be unlocked ("Passcode not set up").

const superadminPasscode = {
    salt: 'vO5+kPEPzWo7X77YprA40w==',
    hash: 'LQbjmoBNoB4yWcNuUv7rmfWgGZgRc4GLKqquYwYHuC4=',
    iterations: 310000
};

export default superadminPasscode;
